import { render, staticRenderFns } from "./EntranceManagement.vue?vue&type=template&id=2a2f246b"
import script from "./EntranceManagement.vue?vue&type=script&lang=js"
export * from "./EntranceManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports